import * as types from './mutation-types';
import store from '@/store';

// TODO: Also implemented in router, merge both of them remove it from router
const actions = {

  updateProjectMaster: ({ commit }, payload) => {
    commit(types.MASTER, payload);
    commit(types.CALCULATESOLDUNITS);
  },

  updateProject: ({ commit }, payload) => {
    const url = window.location.href;
    if (url.includes('/edit-inventory/')) {
      const projectId = url.substr(url.indexOf('/edit-inventory/')
        + '/edit-inventory/'.length, url.length);
      if (`${projectId}` === `${payload.id}`)
        store.dispatch('auctioneer/getInventoryDetails', payload.id);
    }
    commit(types.UPDATEPROJECT, payload);
  },

  addProject: ({ commit }, payload) => {
    commit(types.ADDPROJECT, payload);
  },

  setLoaderState: ({ commit }, payload) => {
    commit(types.SETLOADER, payload);
  },

  updateInternalMaster: ({ commit }, payload) => {
    commit(types.INTERNALMASTER, payload);
    commit(types.CALCULATESOLDUNITS);
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/master/actions.js